import { useLocation } from 'react-router-dom';
import { decodeParams } from '@marvelapp/core';
export function useLocationQueryParams() {
    const location = useLocation();
    return decodeParams(location.search);
}
